import { defineStyle, SystemStyleInterpolation } from '@chakra-ui/react';

const large = defineStyle({
  fontSize: 'md',
  gap: 2,
  height: 14,
  fontWeight: 'medium',
  lineHeight: 'shorter',
});

const small = defineStyle({
  fontSize: 'xs',
  gap: 2,
  h: 8,
  fontWeight: 'medium',
  lineHeight: 'shorter',
});

const medium = defineStyle({
  fontSize: 'sm',
  gap: 2,
  h: 12,
  padding: 4,
  fontWeight: 'medium',
  lineHeight: 'shorter',
});

const addButtonSpacing = defineStyle({
  ...medium,
  gap: 0,
  paddingInlineStart: 3,
  paddingInlineEnd: 5,
});

export enum buttonSizeKeys {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  ADD_BUTTON_SPACING = 'addButtonSpacing',
}

const buttonSizes: Record<buttonSizeKeys, SystemStyleInterpolation> = {
  small,
  medium,
  large,
  addButtonSpacing,
};
export default buttonSizes;
